<div>
  <app-mat-spinner-overlay *ngIf="showSpinner"></app-mat-spinner-overlay>

  <form #diburseCollectionForm="ngForm" novalidate (keydown.enter)="onSearchDisbursCollcetionReport()"
    class="formborder">
    <div class="row m-0">
      <div class="col-md-2">
        <span class="required-lable"> From Date </span>

        <div class="datepicker_feild">
          <input required [matDatepicker]="picker" dateConvert placeholder="DD/MM/YYYY" name="FromDate" id="FromDate"
            #refFromDate="ngModel" class="form-control input-text-css" [(ngModel)]="FromDate" [ngClass]="{
              'is-invalid':
                diburseCollectionForm.submitted && refFromDate.invalid,
              'alert-warning':
                refFromDate.invalid &&
                (refFromDate.dirty ||
                  refFromDate.touched ||
                  refFromDate.untouched)
            }" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </div>
      </div>

      <div class="col-md-2">
        <span class="required-lable"> To Date </span>

        <div class="datepicker_feild">
          <input required [matDatepicker]="picker2" dateConvert placeholder="DD/MM/YYYY" name="ToDate" id="ToDate"
            #refToDate="ngModel" class="form-control input-text-css" [(ngModel)]="ToDate" [ngClass]="{
              'is-invalid':
                diburseCollectionForm.submitted && refToDate.invalid,
              'alert-warning':
                refToDate.invalid &&
                (refToDate.dirty || refToDate.touched || refToDate.untouched)
            }" />
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </div>
      </div>

      <div class="col-md-2 mb-2">
        <button type="button" (click)="onSearchDisbursCollcetionReport()" class="mt-3 btn font-size-12 button-btn"
          [disabled]="!diburseCollectionForm.form.valid">
          Search
        </button>
      </div>
      <div class="col-md-4 mt-3 mb-2">
        <form action="" class="search-text">
          <div class="bg-light rounded rounded-pill shadow-sm">
            <div class="input-group">
              <input type="text" id="FilterInputSearch" (keyup)="applyFilter($event.target.value)"
                name="FilterInputSearch" placeholder="What're you searching for?"
                class="form-control border-0 bg-light" />
              <div class="input-group-append">
                <button id="button-addon1" type="submit" class="btn btn-link text-primary">
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </form>
</div>

<div class="table-responsive mt-3" *ngIf="dataSource">
  <mat-table class="table-bordered" matSort [dataSource]="dataSource" matTableExporter #exporter="matTableExporter"
    style="height: 65vh; overflow: auto; max-width: 100%">
    <ng-container matColumnDef="Loan_Id">
      <mat-header-cell mat-sort-header *matHeaderCellDef>#</mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Application_No">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Application No</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.Application_No }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>
    <ng-container matColumnDef="CIFNo">
      <mat-header-cell mat-sort-header *matHeaderCellDef>CIFNo</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.CIFNo }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Application_Date">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Application Date</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.Application_Date }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="LoanAcNo">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Loan No</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.LoanAcNo }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Loan_Date">
      <mat-header-cell mat-sort-header *matHeaderCellDef>
        Loan Date
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.Loan_Date }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="FirstEMIDate">
      <mat-header-cell mat-sort-header *matHeaderCellDef>First EMI Date</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.FirstEMIDate }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="ExpiryDate">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Expiry Date</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.ExpiryDate }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Product_Name">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Product</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.Product_Name }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Branch_Name">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Branch</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.Branch_Name }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Customer_Name">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Customer</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.Customer_Name }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Customer_Gender">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Gender</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.Customer_Gender }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Customer_DOB">
      <mat-header-cell mat-sort-header *matHeaderCellDef>DOB</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.Customer_DOB }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Customer_PhoneNo">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Phone No</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span *ngIf="currentUser?.IsMaskingMobile"> {{ row.Customer_PhoneNo | mask }}</span>
        <span *ngIf="!currentUser?.IsMaskingMobile">{{ row.Customer_PhoneNo }}</span>
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Customer_Email">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Email</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span *ngIf="currentUser?.IsMaskingMobile">{{ row.Customer_Email | emailmask }}</span><span
          *ngIf="!currentUser?.IsMaskingMobile">{{ row.Customer_Email }}</span>
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Customer_Other_Email">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Customer Other Email</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span *ngIf="currentUser?.IsMaskingMobile">{{ row.Customer_Other_Email | emailmask }}</span><span
          *ngIf="!currentUser?.IsMaskingMobile">{{ row.Customer_Other_Email }}</span>
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="AadharNo">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Aadhar No</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.AadharNo }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="PAN_No">
      <mat-header-cell mat-sort-header *matHeaderCellDef>PAN No</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.PAN_No }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Bank_AccountNo">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Bank Account No</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.Bank_AccountNo }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="IFSCCode">
      <mat-header-cell mat-sort-header *matHeaderCellDef>IFSC Code</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.IFSCCode }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Bankname">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Bank Name</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.Bankname }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Bank_Branch">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Bank Branch</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.Bank_Branch }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="AccType">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Account Type</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.AccType }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef>Total:</mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="LoanAmount">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Loan Amount</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.LoanAmount }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef>{{
        totaltypewise("LoanAmount")
        }}</mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Installment_Amount">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Installment Amount</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.Installment_Amount }}
      </mat-cell>

      <mat-footer-cell *matFooterCellDef>{{
        totaltypewise("Installment_Amount")
        }}</mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Tenure">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Tenure</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.Tenure }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="AgreementAmount">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Agreement Amount</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.AgreementAmount }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef>
        {{ totaltypewise("AgreementAmount") }}</mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Frequency">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Frequency</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.Frequency }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Interest_Rate">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Interest Rate</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.Interest_Rate }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="TotalDeduction">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Total Deduction</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.TotalDeduction }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef>{{
        totaltypewise("TotalDeduction")
        }}</mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="TotalDeductionGST">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Total Deduction GST</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.TotalDeductionGST }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef>{{
        totaltypewise("TotalDeductionGST")
        }}</mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="ToBeDisbursment">
      <mat-header-cell mat-sort-header *matHeaderCellDef>To Be Disbursment</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.ToBeDisbursment }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef>{{
        totaltypewise("ToBeDisbursment")
        }}</mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="NetDisbursment">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Net Disbursment</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.NetDisbursment }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef>{{
        totaltypewise("NetDisbursment")
        }}</mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="PendingDisbursement">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Pending Disbursement</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.PendingDisbursement }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef>{{
        totaltypewise("PendingDisbursement")
        }}</mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Last_Pay_Date">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Last Pay Date</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.Last_Pay_Date }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="InstalmentDue">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Instalment Due</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.InstalmentDue }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef>{{
        totaltypewise("InstalmentDue")
        }}</mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="InstalmentReceived">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Instalment Received</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.InstalmentReceived }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef>{{
        totaltypewise("InstalmentReceived")
        }}</mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="InstalmentBalance">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Instalment Balance</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.InstalmentBalance }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef>{{
        totaltypewise("InstalmentBalance")
        }}</mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Last_Recdved_Date">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Last Received Date</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.Last_Recdved_Date }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Day_Use">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Day Use</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.Day_Use }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Accrued_Interest">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Accrued Interest</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.Accrued_Interest | number : "1.2-2" }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Accrued_Balance">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Accrued Balance</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.Accrued_Balance }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef>{{
        totaltypewise("Accrued_Balance")
        }}</mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="FI_By">
      <mat-header-cell mat-sort-header *matHeaderCellDef>FI Done By</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.FI_By }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="CreditRecomdationBy">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Credit Recommdation By</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.CreditRecomdationBy }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="CreaditApprovedBy">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Credit Approved By</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.CreaditApprovedBy }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Collection_Executive">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Collection Executive</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.Collection_Executive }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="ApplicationCreateBy">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Application Created By</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.ApplicationCreateBy }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="sticky-footer fontcolor"
      style="background: var(--theme-primary); max-height: 0.3125rem"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns" (click)="highlightRow(row)"
      [class.highlight]="row.Loan_Id == selectedId"></mat-row>

    <mat-footer-row class="sticky-footer fontcolor" *matFooterRowDef="displayedColumns; sticky: true"
      style="background: var(--theme-primary)"></mat-footer-row>
  </mat-table>
</div>

<div class="row m-0 ml-3" [hidden]="!dataSource">
  <div class="col-md-4 mt-3">
    <button class="mt-2 btn font-size-12 button-btn" (click)="exportExcel()">
      <i class="fa fa-file-export mr-1" style="font-size: medium; cursor: pointer"></i>
      Export
    </button>
  </div>
  <div class="col-md-8 mt-3">
    <mat-paginator #paginatorRef [pageSizeOptions]="[20, 50]" showFirstLastButtons></mat-paginator>
  </div>
</div>

<table id="disburse_collection" class="table table-bordered bg-white"
  style="font-family: 'Times New Roman', Times, serif; display: none">
  <tr>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">#</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Application No
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Application Date
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Loan No
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Loan Date
    </th>

    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      First EMI Date
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Expiry Date
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Product Name
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Branch
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Customer Name
    </th>

    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Customer Gender
    </th>

    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Customer DOB
    </th>

    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Customer Phone No
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Customer Email
    </th>

    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Customer Other Email
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Aadhar No
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      PAN No
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Bank Account No
    </th>

    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      IFSC Code
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Bank name
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Bank Branch
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Account Type
    </th>

    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Loan Amount
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Installment Amount
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Tenure
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Agreement Amount
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Frequency
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Interest Rate
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Total Deduction
    </th>

    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Total Deduction GST
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      To Be Disbursment
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Net Disbursment
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Pending Disbursement
    </th>

    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Last Pay Date
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Instalment Due
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Instalment Received
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Instalment Balance
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Last Received Date
    </th>

    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Day Use
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Accrued Interest
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Accrued Balance
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      FI Done By
    </th>

    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Credit Recommdation Done By
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Credit Approved By
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Collection Executive
    </th>

    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Application Created By
    </th>
  </tr>
  <tr *ngFor="let x of JsonData; let i = index">
    <td>{{ i + 1 }}</td>
    <td>{{ x.Application_No }}</td>
    <!-- formatDateForExcel for Excel date formatting -->
    <td style="mso-number-format:'dd\/mm\/yy';">{{ formatDateForExcel(x.Application_Date) }}</td>
    <td>{{ x.LoanAcNo }}</td>
    <td style="mso-number-format:'dd\/mm\/yy';">{{ formatDateForExcel(x.Loan_Date) }}</td>

    <td style="mso-number-format:'dd\/mm\/yy';">{{ formatDateForExcel(x.FirstEMIDate) }}</td>
    <td style="mso-number-format:'dd\/mm\/yy';">{{ formatDateForExcel(x.ExpiryDate) }}</td>
    <td>{{ x.Product_Name }}</td>
    <td>{{ x.Branch_Name }}</td>
    <td>{{ x.Customer_Name }}</td>

    <td>{{ x.Customer_Gender }}</td>
    <td style="mso-number-format:'dd\/mm\/yy';">{{ formatDateForExcel(x.Customer_DOB) }}</td>

    <td>{{ x.Customer_PhoneNo }}</td>
    <td><span *ngIf="currentUser?.IsMaskingMobile">{{ x.Customer_Email | emailmask }}</span><span
        *ngIf="!currentUser?.IsMaskingMobile">{{ x.Customer_Email }}</span></td>
    <td><span *ngIf="currentUser?.IsMaskingMobile">{{ x.Customer_Other_Email | emailmask }}</span><span
        *ngIf="!currentUser?.IsMaskingMobile">{{ x.Customer_Other_Email }}</span></td>
    <td>{{ x.AadharNo }}</td>
    <td>{{ x.PAN_No }}</td>
    <td>{{ x.Bank_AccountNo }}</td>
    <td>{{ x.IFSCCode }}</td>

    <td>{{ x.Bankname }}</td>
    <td>{{ x.Bank_Branch }}</td>
    <td>{{ x.AccType }}</td>
    <td>{{ x.LoanAmount }}</td>

    <td>{{ x.Installment_Amount }}</td>
    <td>{{ x.Tenure }}</td>
    <td>{{ x.AgreementAmount }}</td>
    <td>{{ x.Frequency }}</td>
    <td>{{ x.Interest_Rate }}</td>
    <td>{{ x.TotalDeduction }}</td>
    <td>{{ x.TotalDeductionGST }}</td>

    <td>{{ x.ToBeDisbursment }}</td>
    <td>{{ x.NetDisbursment }}</td>
    <td>{{ x.PendingDisbursement }}</td>
    <td style="mso-number-format:'dd\/mm\/yy';">{{ formatDateForExcel(x.Last_Pay_Date) }}</td>

    <td>{{ x.InstalmentDue }}</td>
    <td>{{ x.InstalmentReceived }}</td>
    <td>{{ x.InstalmentBalance }}</td>
    <td style="mso-number-format:'dd\/mm\/yy';">{{ formatDateForExcel(x.Last_Recdved_Date) }}</td>
    <td>{{ x.Day_Use }}</td>

    <td>{{ x.Accrued_Interest }}</td>
    <td>{{ x.Accrued_Balance }}</td>
    <td>{{ x.FI_By }}</td>
    <td>{{ x.CreditRecomdationBy }}</td>
    <td>{{ x.CreaditApprovedBy }}</td>
    <td>{{ x.Collection_Executive }}</td>
    <td>{{ x.ApplicationCreateBy }}</td>
  </tr>

  <tfoot>
    <tr>
      <td colspan="22" style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        ">
        <b>Total:</b>
      </td>
      <td style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        ">
        <strong>{{ totaltypewise("LoanAmount") }}</strong>
      </td>
      <td style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        ">
        <strong>{{ totaltypewise("Installment_Amount") }}</strong>
      </td>
      <td style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        ">
        <b></b>
      </td>

      <td style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        ">
        <strong>{{ totaltypewise("AgreementAmount") }}</strong>
      </td>
      <td style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        ">
        <b></b>
      </td>
      <td style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        ">
        <b></b>
      </td>
      <td style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        ">
        <strong>{{ totaltypewise("TotalDeduction") }}</strong>
      </td>

      <td style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        ">
        <strong>{{ totaltypewise("TotalDeductionGST") }}</strong>
      </td>
      <td style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        ">
        <strong>{{ totaltypewise("ToBeDisbursment") }}</strong>
      </td>
      <td style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        ">
        <strong>{{ totaltypewise("NetDisbursment") }}</strong>
      </td>
      <td style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        ">
        <strong>{{ totaltypewise("PendingDisbursement") }}</strong>
      </td>
      <td style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "></td>
      <td style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        ">
        <strong>{{ totaltypewise("InstalmentDue") }}</strong>
      </td>
      <td style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        ">
        <strong>{{ totaltypewise("InstalmentReceived") }}</strong>
      </td>
      <td style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        ">
        <strong>{{ totaltypewise("InstalmentBalance") }}</strong>
      </td>
      <td style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "></td>
      <td style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "></td>
      <td style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "></td>
      <td style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        ">
        <strong>{{ totaltypewise("Accrued_Balance") }}</strong>
      </td>
      <td style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "></td>
      <td style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "></td>
      <td style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "></td>
      <td style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "></td>
      <td style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "></td>
    </tr>
  </tfoot>
</table>